// Core imports
import * as React from 'react';
import LocaleFormating from 'src/translation/localeFormating';
import env from 'src/shared/env';

// Components imports
import Button from 'src/components/common/Button';
import RadioButton from 'src/components/common/RadioButton';
import ECheckModalDesktop from '../ECheckModalDesktop';
import PayInvoiceRow from '../PayInvoiceRow';
import CheckPrintable from '../CheckPrintable';
import Input from 'src/components/common/Input';
import Alert from 'src/components/common/Alert';

// Models imports
import InvoiceModel from 'src/model/invoice.model';
import {
  IFiltersInvoice,
  IInvoiceCreditPayment
} from 'src/services/invoice/InvoiceService';
import CreditCardModel from 'src/model/creditCard.model';
import {
  ICreditCardError,
  ICreditCardSuccess
} from 'src/store/modules/creditcard/reducers';

// Style and misc imports
import './PaymentModeDesktop.scss';
import { startEndWithWhiteSpacesValidation } from 'src/utils/whiteSpacesValidation';
import UserModel from 'src/model/user.model';

class PaymentModeDesktop extends React.Component<
  IPaymentModeDesktopProps,
  IPaymentModeDesktopState
> {
  constructor(props: IPaymentModeDesktopProps) {
    super(props);

    this.state = {
      selectedMode: 'check',
      printCheck: false,
      showECheckModalDesktop: false,
      invoicesPaymentData: [],
      totalPayable: 0,
      isPaymentDisabled: false,
      creditSignature: '',
      invoices: []
    };
  }

  /* 
    getTotalDue
   */
  private getTotalDue = (): {
    total: number;
    totalDebit: number;
    totalCredit: number;
  } => {
    let total: number = 0;
    let totalCredit: number = 0;
    let totalDebit: number = 0;
    this.state.invoicesPaymentData.map(invoice => {
      total =
        Number(total.toFixed(2)) +
        Number(invoice.payment ? invoice.payment : 0);
      if (invoice.payment && invoice.payment > 0) {
        totalDebit = Number(totalDebit.toFixed(2)) + Number(invoice.payment);
      } else {
        totalCredit = Number(totalCredit.toFixed(2)) + Number(invoice.payment);
      }
    });
    return {
      total: Number(total.toFixed(2)),
      totalDebit: Number(totalDebit.toFixed(2)),
      totalCredit: Number(totalCredit.toFixed(2))
    };
  };

  /* 
    setSelectedPaymentMode
   */
  private setSelectedPaymentMode = (event: any) => {
    this.setState({
      selectedMode: event.target.value
    });
    this.props.clearAlert();
  };

  /* 
    getSelectedMode
   */
  private getSelectedMode = () => {
    const selections = {
      creditCard: false,
      check: false,
      echeck: false,
      credit: false
    };

    selections[this.state.selectedMode] = true;
    return selections;
  };

  /* 
    getInvoices
   */
  private getInvoices = (): {
    credits: JSX.Element[];
    invoices: JSX.Element[];
  } => {
    const invoices: JSX.Element[] = [];
    const credits: JSX.Element[] = [];

    this.state.invoices.map((invoice, index) => {
      if (invoice.remainingAmount < 0) {
        credits.push(
          <PayInvoiceRow
            key={index}
            invoice={invoice}
            onDataChange={this.handleInvoicePaymentValues}
          />
        );
      } else {
        invoices.push(
          <PayInvoiceRow
            key={index}
            invoice={invoice}
            onDataChange={this.handleInvoicePaymentValues}
          />
        );
      }
    });

    return { credits, invoices };
  };

  /* 
    handleCloseCheck
   */
  private handleCloseCheck = () => {
    if (this.state.printCheck === true) {
      this.setState({ printCheck: false });
    }
  };

  /* 
    handlePayment
   */
  private handlePayment = () => {
    switch (this.state.selectedMode) {
      case 'check':
        this.setState({ printCheck: true });
        this.props.clearAlert();
        break;
      case 'creditCard':
        this.handleCreditCardPayment();
        this.props.clearAlert();
        break;
      case 'echeck':
        this.setState({ showECheckModalDesktop: true });
        this.props.clearAlert();
        break;
      case 'credit':
        this.handleCreditPayment();
        this.props.clearAlert();
        break;
      default:
        break;
    }
  };

  private handleCreditPayment = () => {
    const invoicesToPay: IInvoiceCreditPayment[] = [];

    this.state.invoicesPaymentData.forEach(invoice => {
      invoicesToPay.push({
        orderNumber: invoice.orderNumber,
        paymentAmount: invoice.payment,
        reasonRemainingBalance: invoice.notes,
        transactionId: invoice.transactionId
      });
    });

    this.props.payInvoicesByCredit(invoicesToPay, this.state.creditSignature);
  };

  private handleCreditCardPayment = () => {
    const invoicesToPay: IInvoiceCreditPayment[] = [];

    this.state.invoicesPaymentData.forEach(invoice => {
      invoicesToPay.push({
        orderNumber: invoice.orderNumber,
        paymentAmount: invoice.payment,
        reasonRemainingBalance: invoice.notes,
        transactionId: invoice.transactionId
      });
    });

    this.props.payInvoicesByCreditCard(
      invoicesToPay,
      this.props.selectedCreditCard.id
    );
  };

  /* 
    handleInvoicePaymentValues
   */
  private handleInvoicePaymentValues = (
    invoicePayment: IInvoicePaymentData
  ) => {
    const index = this.state.invoicesPaymentData.findIndex(
      invoice => invoice.invoiceNumber === invoicePayment.invoiceNumber
    );

    const paymentData: IInvoicePaymentData[] = [
      ...this.state.invoicesPaymentData
    ];
    if (index === -1) {
      paymentData.push(invoicePayment);
    } else {
      paymentData[index] = invoicePayment;
    }

    this.setState({ invoicesPaymentData: paymentData }, () => {
      if (
        !invoicePayment.payment ||
        (invoicePayment.remaining > 0 && !invoicePayment.notes)
      ) {
        this.setState({
          isPaymentDisabled: true
        });
      } else {
        let isDisabled = false;
        for (const invoice of this.state.invoicesPaymentData) {
          if (
            !invoice.payment ||
            (invoicePayment.remaining > 0 && !invoicePayment.notes)
          ) {
            isDisabled = true;
            break;
          }
        }

        this.setState({
          isPaymentDisabled: isDisabled
        });
      }
    });
  };
  /* 
    prepareCheckData
   */
  private prepareCheckData = () => {
    const preparedData: IInvoicePaymentData[] = [];
    this.props.selectedInvoices.forEach(invoice => {
      const paymentData: IInvoicePaymentData = {
        transactionId: invoice.transactionId,
        invoiceDate: invoice.dueDate,
        invoiceNumber: invoice.invoiceNumber,
        orderNumber: invoice.orderNumber,
        payment: invoice.remainingAmount,
        remaining: 0,
        total: invoice.remainingAmount,
        notes: ''
      };
      preparedData.push(paymentData);
    });
    this.setState({ invoicesPaymentData: preparedData });
  };
  /* 
    handleCloseECheckModal
   */
  private handleCloseECheckModalDesktop = () => {
    this.setState({
      showECheckModalDesktop: false
    });

    this.props.closeModal();
  };

  private onCreditSignatureChange = (creditSignature: string) => {
    if (
      !creditSignature ||
      (creditSignature !== ' ' &&
        !startEndWithWhiteSpacesValidation(creditSignature))
    ) {
      this.setState({ creditSignature });
    }
  };

  private renderAlert() {
    const getMessage = () =>
      this.props.errorPayment.hasFailed
        ? this.props.errorPayment.message
        : this.props.successPayment.hasSucceed
        ? this.props.successPayment.message
        : this.props.creditCardError.hasFailed
        ? this.props.creditCardError.message
        : this.props.creditCardSuccess.message;

    return (this.props.errorPayment && this.props.errorPayment.hasFailed) ||
      (this.props.successPayment && this.props.successPayment.hasSucceed) ||
      (this.props.creditCardError && this.props.creditCardError.hasFailed) ||
      (this.props.creditCardSuccess &&
        this.props.creditCardSuccess.hasSucceed) ? (
      <div className="rp-payment-mode-desktop--alert">
        <Alert
          styleClass="paymentAlert"
          message={!this.props.creditCardError.hasFailed && getMessage()}
          icon={
            this.props.errorPayment.hasFailed ||
            this.props.creditCardError.hasFailed
              ? 'rpds-error'
              : 'rpds-check-circle'
          }
          handleCloseAlert={() => {
            return;
          }}
          type={
            this.props.errorPayment.hasFailed ||
            this.props.creditCardError.hasFailed
              ? 'error'
              : 'success'
          }
        >
          {this.props.creditCardError.hasFailed &&
            getMessage()
              .split('-')
              .map((msg: string, idx: number) => (
                <span className="alert-extra-area-message" key={idx}>
                  {msg}
                </span>
              ))}
        </Alert>
      </div>
    ) : null;
  }

  private renderCreditCardOptions = () => {
    const { t } = this.props;
    return this.props.savedCreditCards &&
      this.props.savedCreditCards.length > 0 ? (
      this.props.creditCardIsPending ? (
        <span className="rp-invoices--saved-cards warning">
          {t('payments.inProcessDoNotLeavePage')}
        </span>
      ) : (
        <div className="rp-invoices--saved-cards">
          {this.props.savedCreditCards.map(card => (
            <RadioButton
              key={card.id}
              name={`**** **** **** ${card.number}`}
              extraText={card.type}
              value={card.id}
              checked={
                card.id === this.props.selectedCreditCard.id ? true : false
              }
              className="rp-radio-button--saved-card"
              onChange={e => this.props.onSelectCreditCard(card)}
            />
          ))}
        </div>
      )
    ) : (
      <span className="rp-invoices--saved-cards">
        {t('common.noSavedCard')}{' '}
      </span>
    );
  };

  /* 
    renderPaymentMethod
   */
  private renderPaymentMethod() {
    if (this.state.printCheck) {
      return (
        <CheckPrintable
          invoices={this.state.invoicesPaymentData}
          closeWindow={() => {
            this.handleCloseCheck();
          }}
          userAccount={this.props.userAccount}
          user={this.props.userData}
        />
      );
    } else if (this.state.showECheckModalDesktop) {
      return (
        <ECheckModalDesktop
          onCloseModal={this.handleCloseECheckModalDesktop}
          invoices={this.state.invoicesPaymentData}
          userAccount={this.props.userAccount}
        />
      );
    } else {
      // TODO: Credit card component
      return <div />;
    }
  }

  private renderProceedPayment() {
    const { t } = this.props;
    const { total, totalDebit, totalCredit } = this.getTotalDue();
    return (
      <React.Fragment>
        {this.state.selectedMode === 'credit' && (
          <div className="rp-payment-mode-desktop--credit-signature">
            <Input
              label={t('common.paymentSignature')}
              value={this.state.creditSignature}
              onChange={this.onCreditSignatureChange}
              required={true}
            />
          </div>
        )}
        <div className="rp-payment-mode-desktop--pay-invoices">
          {this.state.selectedMode === 'credit' && (
            <div className="payment-total">
              <p>{`Credit: ${LocaleFormating.formatCurrency(totalCredit)}`}</p>
              <p>{`Debit: ${LocaleFormating.formatCurrency(totalDebit)}`}</p>
            </div>
          )}
          <span className="payment-total">
            {`${t('common.total')}: ${LocaleFormating.formatCurrency(total)}`}
          </span>
          <Button
            buttonClass="primary-custom-button pay-invoices-button"
            label={t('invoices.payInvoiceWithCount', {
              count: this.state.totalPayable
            })}
            textTransform="uppercase"
            height="40px"
            width="168px"
            action={this.handlePayment}
            disabled={
              this.state.isPaymentDisabled ||
              (this.state.selectedMode === 'credit' &&
                !this.state.creditSignature) ||
              total < 0 ||
              (this.state.selectedMode !== 'credit' && total === 0) ||
              (this.props.successPayment &&
                this.props.successPayment.hasSucceed) ||
              (this.state.selectedMode === 'creditCard' &&
                (!this.props.selectedCreditCard ||
                  this.props.creditCardIsPending)) ||
              (this.props.creditCardSuccess &&
                this.props.creditCardSuccess.hasSucceed)
            }
          />
        </div>
        {this.state.selectedMode === 'credit' && (
          <div className="rp-payment-mode-desktop--credit-items-offset">
            <span className="credits-text">
              {`${t('invoices.creditsItemsOffset')}`}
            </span>
          </div>
        )}
      </React.Fragment>
    );
  }

  public componentDidMount() {
    this.props.getUserDetails();
    this.prepareCheckData();
    this.setState({
      totalPayable: this.props.selectedInvoices.length,
      invoices: this.props.selectedInvoices
    });
    this.props.getSavedCards();
  }

  public render() {
    const { t } = this.props;
    const methodSelection = this.getSelectedMode();
    const { invoices, credits } = this.getInvoices();

    return (
      <div className="rp-payment-mode-desktop">
        {this.renderAlert()}
        {!this.props.creditCardIsPending && (
          <i
            className="rpds-close close-modal"
            onClick={this.props.closeModal}
          />
        )}
        <div className="rp-payment-mode-desktop--payment-methods">
          <h1 className="payments-title">{t('payment.chooseMethod')}</h1>
          <div className="method-container">
            <div className="payment-method">
              <RadioButton
                name={
                  env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                    ? t('payment.byCheckCA')
                    : t('payment.byCheck')
                }
                value="check"
                checked={methodSelection.check}
                onChange={event => {
                  this.setSelectedPaymentMode(event);
                }}
              />
              <i className="rpds-i" />
            </div>
            {env.REACT_APP_INVOICE_CC_PAYMENT === 'true' && (
              <div className="payment-method">
                <RadioButton
                  name={t('payment.byCreditCard')}
                  value="creditCard"
                  checked={methodSelection.creditCard}
                  onChange={event => {
                    this.setSelectedPaymentMode(event);
                  }}
                />
                {methodSelection.creditCard && this.renderCreditCardOptions()}
              </div>
            )}
            {env.REACT_APP_BASE_ENVIRONMENT === 'US' && (
              <div className="payment-method">
                <RadioButton
                  name={t('payment.byEcheck')}
                  value="echeck"
                  checked={methodSelection.echeck}
                  onChange={event => {
                    this.setSelectedPaymentMode(event);
                  }}
                />
                <div className="payment-title">
                  <span className="title">{t('payment.secureExternal')}</span>
                </div>
              </div>
            )}
            <div className="payment-method">
              <RadioButton
                name={t('payment.byCredit')}
                value="credit"
                checked={methodSelection.credit}
                onChange={event => {
                  this.setSelectedPaymentMode(event);
                }}
              />
            </div>
          </div>
        </div>
        {this.renderProceedPayment()}
        <div className="rp-payment-mode-desktop--invoices">
          {credits.length > 0 && (
            <React.Fragment>
              <div className="invoices-header">
                <span>{t('invoices.credit_plural')}</span>
                <span>{t('invoices.totalAmount')}</span>
                <span>{t('invoices.paymentAmount')}</span>
                <span>{t('common.remaining')}</span>
                <span />
              </div>
              {credits}
            </React.Fragment>
          )}
          <div className="invoices-header">
            <span>{t('invoices.invoice_plural')}</span>
            <span>{t('invoices.totalAmount')}</span>
            <span>{t('invoices.paymentAmount')}</span>
            <span>{t('common.remaining')}</span>
            <span>{t('invoices.reasonForRemainingBalance')}</span>
          </div>
          {invoices}
        </div>
        {this.renderPaymentMethod()}
      </div>
    );
  }
}

export default PaymentModeDesktop;

interface IPaymentModeDesktopProps {
  closeModal(): void;
  t: any;
  selectedInvoices: InvoiceModel[];
  userAccount: string;
  errorPayment: any;
  successPayment: any;
  filters: IFiltersInvoice;
  savedCreditCards: CreditCardModel[];
  selectedCreditCard: CreditCardModel;
  creditCardError: ICreditCardError;
  creditCardSuccess: ICreditCardSuccess;
  creditCardIsPending: boolean;
  userData: UserModel;
  payInvoicesByCredit: (
    invoicePayments: IInvoiceCreditPayment[],
    signature: string
  ) => void;
  clearAlert: () => void;
  getSavedCards: () => void;
  onSelectCreditCard(creditCard: CreditCardModel): void;
  payInvoicesByCreditCard: (
    invoicePayments: IInvoiceCreditPayment[],
    cardId: string
  ) => void;
  getUserDetails: () => void;
}

interface IPaymentModeDesktopState {
  selectedMode: 'check' | 'creditCard' | 'echeck' | 'credit';
  printCheck: boolean;
  showECheckModalDesktop: boolean;
  invoicesPaymentData: IInvoicePaymentData[];
  totalPayable: number;
  isPaymentDisabled: boolean;
  creditSignature: string;
  invoices: InvoiceModel[];
}

export interface IInvoicePaymentData {
  transactionId: number;
  invoiceDate: string;
  invoiceNumber: number;
  orderNumber: number;
  payment: number;
  remaining: number;
  total: number;
  notes: string;
}
